import { render, staticRenderFns } from "./WordAccountMobile.vue?vue&type=template&id=b1c2f49e&scoped=true&"
import script from "./WordAccountMobile.vue?vue&type=script&lang=js&"
export * from "./WordAccountMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c2f49e",
  null
  
)

export default component.exports